// extracted by mini-css-extract-plugin
module.exports = {"table-container":"CanceledOrders_table-container__2ZCcz","table":"CanceledOrders_table__3TNDa"};